$(document).ready(function(){

	$('.medal .items-group').sortable({ 
		revert: true,
		forcePlaceholderSize: true, 
		handle: '.btn-reorder',
		placeholder: '.medal .items-group', 
		cursor: 'move',
		stop: function(event, ui) {
			rebuildTop();
		}
		/*,
		start: function(event, ui) {
			$(ui.helper).toggleClass('_isDragged');
		},

		beforeStop: function(event, ui) {
			$(ui.helper).toggleClass('_isDragged');
		}*/
	});

});